/**
 * Critical PDP mobile size sheet open/close.
 * Loaded without defer from buy-buttons. Desktop must never run this.
 * Safe to call from deferred global.js via window.setMobileSizeSelectorOpen.
 */
(function () {
  if (window.__pdpMobileAtcInit) return;
  window.__pdpMobileAtcInit = true;

  // Match .hide-desktop breakpoint — not user-agent (DevTools / tablets break UA checks)
  var MOBILE_MQ = '(max-width: 767px)';

  function isMobileAtcViewport() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function refreshStickyHeight() {
    if (!isMobileAtcViewport()) return;
    if (typeof window.updateStickyAtcHeight === 'function') {
      window.updateStickyAtcHeight();
      return;
    }
    var btnWrapper =
      document.getElementById('PdpStickyAtc') || document.querySelector('.product-form__buttons');
    if (!btnWrapper || btnWrapper.classList.contains('size-selector-open')) return;
    document.documentElement.style.setProperty(
      '--pdp-sticky-atc-height',
      btnWrapper.offsetHeight + 'px'
    );
  }

  function setMobileSizeSelectorOpen(isOpen) {
    // Never touch #size-swatches display on desktop — inline display:none hides PDP sizes permanently
    if (!isMobileAtcViewport()) return;

    var btnWrapper =
      document.getElementById('PdpStickyAtc') || document.querySelector('.product-form__buttons');
    var sizeSelectorWrap = document.getElementById('size-swatches');
    if (!sizeSelectorWrap) return;

    if (isOpen) {
      if (btnWrapper) btnWrapper.classList.add('size-selector-open');
      document.documentElement.style.setProperty('--pdp-sticky-atc-height', '0px');
      sizeSelectorWrap.style.display = 'block';
      if (typeof window.syncPdpStickyAtc === 'function') window.syncPdpStickyAtc();
    } else {
      // Clear inline style so mobile CSS (display:none) applies — do NOT set display:none inline
      // (that would also hide sizes if this ever ran at desktop widths)
      sizeSelectorWrap.style.removeProperty('display');
      if (btnWrapper) btnWrapper.classList.remove('size-selector-open');
      refreshStickyHeight();
      if (typeof window.syncPdpStickyAtc === 'function') window.syncPdpStickyAtc();
      document.body.style.overflow = 'auto';
    }
  }

  function bindSizeSheetControls() {
    if (!isMobileAtcViewport()) return;

    var sizeSelectorBtn = document.getElementById('sizeSelector');
    var sizeSelectorWrap = document.getElementById('size-swatches');
    var sizeSelectorClose = document.getElementById('sizeSelectorClose');
    if (!sizeSelectorBtn || !sizeSelectorWrap) return;

    sizeSelectorBtn.addEventListener('click', function (event) {
      if (!isMobileAtcViewport()) return;
      event.preventDefault();
      event.stopPropagation();
      setMobileSizeSelectorOpen(true);
    });

    if (sizeSelectorClose) {
      sizeSelectorClose.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setMobileSizeSelectorOpen(false);
      });
    }

    document.querySelectorAll('.size_guide-wrapper_sm').forEach(function (el) {
      el.addEventListener('click', function () {
        setMobileSizeSelectorOpen(false);
      });
    });

    document.addEventListener('click', function (event) {
      if (!isMobileAtcViewport()) return;
      if (
        !sizeSelectorWrap.contains(event.target) &&
        sizeSelectorWrap.style.display === 'block'
      ) {
        event.stopPropagation();
        setMobileSizeSelectorOpen(false);
      }
    });
  }

  window.setMobileSizeSelectorOpen = setMobileSizeSelectorOpen;

  // Heal desktop if a prior mobile path left inline display:none on sizes
  if (!isMobileAtcViewport()) {
    var heal = document.getElementById('size-swatches');
    if (heal) heal.style.removeProperty('display');
  } else {
    bindSizeSheetControls();
    if (typeof window.syncPdpStickyAtc === 'function') {
      window.syncPdpStickyAtc();
    }
  }
})();
